<template>
  <div class="last_page_wrapper">
    <div class="icon_area">
      <div class="page_icon"></div>
    </div>
    <div class="text_area">
      <div class="thanx_title">
        {{ title }}
      </div>
      <div
        class="thanx_desc"
        v-html="$options.filters.newLineToBr(description)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepThanks',
  computed: {
    title() {
      return 'TEBRİKLER, İÇ MİMARLIK HİZMETİ ALMAK İÇİN İLK ADIMI ATTINIZ!';
    },
    description() {
      return 'Başvurunuzu aldık, en kısa sürede tarafınıza geri dönüş sağlanacaktır.';
    },
  },
};
</script>
